import { Routes } from '@angular/router';
import { AUTH_ROUTES } from '@core/auth';
import { AuthGuard } from '@core/auth/guards/auth.guard';
import { DASHBOARD_ROUTES } from './features/dashboard/dashboard.routes';
import { KOPPEL_ROUTES } from './features/koppel/koppel.routes';
import { SLAUGHTER_LIST_ROUTES } from './features/slaughter-list/slaughter-list.routes';
import { HEALTH_REGISTRATION_ROUTES } from './features/health-registration/health-registration.routes';
import { MEDICATION_REGISTRATIONS_ROUTES } from './features/medication-registrations/medication-registrations.routes';
import { SETTINGS_ROUTES } from './features/settings/settings.routes';
import { FEED_ROUTES } from './features/feed/feed.routes';
import { STARTERS_LIST_ROUTES } from './features/starters-list/starters-list.routes';

export const routes: Routes = [
  // Public routes
  ...AUTH_ROUTES,

  // Protected routes
  {
    path: 'dashboard',
    children: DASHBOARD_ROUTES
  },
  {
    path: 'koppels',
    children: KOPPEL_ROUTES
  },
  {
    path: 'witvlees',
    children: KOPPEL_ROUTES
  },
  {
    path: 'starters',
    children: KOPPEL_ROUTES
  },
  {
    path: 'recente-imports',
    loadComponent: () =>
      import('./features/recente-imports/recente-imports.component').then(m => m.RecenteImportsComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'rose',
    children: KOPPEL_ROUTES
  },
  {
    path: 'slaughter-lists',
    children: SLAUGHTER_LIST_ROUTES
  },
  {
    path: 'starters-lists',
    children: STARTERS_LIST_ROUTES
  },
  {
    path: 'health-registrations',
    children: HEALTH_REGISTRATION_ROUTES
  },
  {
    path: 'medication-registrations',
    children: MEDICATION_REGISTRATIONS_ROUTES
  },
  {
    path: 'settings',
    children: SETTINGS_ROUTES
  },
  {
    path: 'feed',
    children: FEED_ROUTES
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  }
];
